var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.75C6.072 1.75 1.25 6.573 1.25 12.5C1.25 18.427 6.072 23.25 12 23.25C17.928 23.25 22.75 18.427 22.75 12.5C22.75 6.573 17.928 1.75 12 1.75ZM21.212 11.75H17.162C17.031 9.007 16.187 6.21201 14.727 3.66101C18.27 4.75701 20.903 7.93 21.212 11.75ZM12.73 3.28699C14.486 5.89799 15.509 8.86 15.662 11.75H8.33801C8.49001 8.86 9.51399 5.89799 11.27 3.28699C11.512 3.26799 11.754 3.25 12 3.25C12.246 3.25 12.489 3.26799 12.73 3.28699ZM9.27301 3.66101C7.81301 6.21201 6.96901 9.007 6.83801 11.75H2.78799C3.09699 7.93 5.73001 4.75701 9.27301 3.66101ZM2.78799 13.25H6.83801C6.96901 15.993 7.81301 18.788 9.27301 21.339C5.73001 20.243 3.09699 17.07 2.78799 13.25ZM11.27 21.713C9.51399 19.102 8.49101 16.14 8.33801 13.25H15.662C15.51 16.14 14.486 19.102 12.73 21.713C12.488 21.732 12.246 21.75 12 21.75C11.754 21.75 11.511 21.732 11.27 21.713ZM14.727 21.339C16.187 18.788 17.031 15.993 17.162 13.25H21.212C20.903 17.07 18.27 20.243 14.727 21.339Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language_icon.d3b738713b1e2929827ebeec8ee7877e.svg";
export { ForwardRef as ReactComponent };